
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FloatingShapeComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { ScreenService } from '@catch/services';
import confetti from 'canvas-confetti';
import { fadeInOut } from '../../../../assets/animations/animations';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { ColorService } from '../../../services/color.service';

@Component({
  selector: 'app-start-phone-call',
  templateUrl: './start-phone-call.component.html',
  styleUrls: ['./start-phone-call.component.scss'],
  animations: [fadeInOut],
  imports: [FloatingShapeComponent, TranslocoPipe],
})
export class StartPhoneCallComponent implements OnInit {
  private readonly colorService = inject(ColorService);
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  public readonly screenService = inject(ScreenService);

  @ViewChild('confettiTrigger') confettiTrigger: ElementRef;

  state: string;

  ngOnInit(): void {
    const nonce: string = this.route.snapshot.queryParams['nonce'];
    console.log(
      nonce,
      nonce.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
      )
    );
    if (
      nonce &&
      nonce.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
      )
    ) {
      this.jobboardAdapter.startPhoneCall(nonce).subscribe({
        next: () => {
          this.state = 'success';
          this.showConfetti();
        },
        error: () => {
          this.state = 'failed';
        },
      });
    } else {
      this.state = 'failed';
    }
  }

  showConfetti(): void {
    confetti({
      particleCount: 50,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  get correctedBackgroundColor(): string {
    if (this.colorService.background) {
      if (
        this.colorService.background.startsWith('rgb') &&
        !this.colorService.background.startsWith('rgba')
      ) {
        return (
          this.colorService.background.substring(
            0,
            this.colorService.background.length - 2
          ) + ', 0.133333)'
        );
      } else if (
        this.colorService.background.startsWith('#') &&
        this.colorService.background.length <= 7
      ) {
        return this.colorService.background + '22';
      } else {
        return this.colorService.background;
      }
    }
    return '';
  }
}
